export const HeartVideoSection = () => (
  <section className="py-20 px-6 bg-forest text-white" data-testid="heart-video-section">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4">
        This Was Never Just About Taking a Trip.
      </h2>
      <p className="text-white/70 mb-10 text-lg">The Heart Behind Just Be</p>

      <div className="relative w-full mb-8" style={{ paddingBottom: '56.25%' }}>
        <iframe
          src="https://player.vimeo.com/video/1174615590?h=&title=0&byline=0&portrait=0"
          className="absolute top-0 left-0 w-full h-full rounded-2xl"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="The Heart Behind Just Be"
        ></iframe>
      </div>

      <p className="text-white/80 text-lg max-w-2xl mx-auto leading-relaxed">
        Crystal Khalil and Dr. Nicole LaBeach share why they created Just Be and what happens when women who are
        accustomed to carrying everyone else finally enter a space designed to carry them.
      </p>
    </div>
  </section>
);
